const documentHeight = () => {
  var documentHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );
  return documentHeight;
};
$(window).on("load", function () {
  documentHeight();
});
$(window).on("resize orientationchange", function () {
  documentHeight();
});
